import React, { useState, useEffect } from "react";
import { useCollection } from "react-firebase-hooks/firestore";
import MainPage from "./MainPage";
import { firebase } from "../../Firebase";
import { runAnalytics } from "../../utils";

function MainPageWrapper() {
  const pageSize = 25;
  const firstPageSize = 50;
  const collection = firebase
    .firestore()
    .collection("current")
    .limit(firstPageSize);

  const [limitResults, setLimitResults] = useState(firstPageSize);
  const [queries, setQueries] = useState(collection);
  const [sites, setSites] = useState([]);
  const [queryError, setQueryError] = useState();

  const loadMore = () => {
    const newPageLimit = limitResults + pageSize;
    setLimitResults(newPageLimit);
    setQueries(queries.limit(newPageLimit));
  };

  const submitQueries = payload => {
    const defaultQuery = firebase
      .firestore()
      .collection("current")
      .limit(firstPageSize);
    const isClearingSearch = payload.length === 1 && payload[0].length === 0;

    if (isClearingSearch) {
      setQueries(collection);
      return;
    }

    if (validateQuery(payload)) {
      const firestoreQuery = payload.reduce((acc, query) => {
        return query.length === 3 ? acc.where(...query) : acc;
      }, defaultQuery);

      setQueries(firestoreQuery);
      setLimitResults(firstPageSize);
    } else {
      handleInvalidQuery();
    }
  };

  const validateQuery = payload => {
    if (payload.length >= 2) {
      const queryOne = payload[0];
      const queryTwo = payload[1];

      const inequality = [">", "<", ">=", "<="];

      if (
        queryOne[0] !== queryTwo[0] &&
        inequality.includes(queryOne[1]) &&
        inequality.includes(queryTwo[1])
      ) {
        return false;
      }
    }
    return true;
  };

  const handleInvalidQuery = () => {
    const errorMessage = (
      <span>
        <strong>
          Sorry, that's not a valid query.
          <br />
          You can't query inequality (ie {`>`} or {`<`}) on different columns.
          <br />
          If you really want this type of filter,{" "}
          <a
            href="mailto:amp@broadlume.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            email the engineering team.
          </a>
        </strong>
      </span>
    );
    setQueryError(errorMessage);
    setTimeout(() => {
      setQueryError();
    }, 10000);

    if (
      runAnalytics({ userEmail: firebase.auth().currentUser.email, window })
    ) {
      window.analytics.track(
        "Filtered Sites: Error - Inequality Separate Columns"
      );
    }
  };

  const [value, loading, error] = useCollection(queries, {
    snapshotListenOptions: { includeMetadataChanges: true }
  });

  useEffect(() => {
    if (value !== undefined) {
      const newSites = value.docs.map(doc => ({
        ...doc.data(),
        url: doc.id
      }));
      setSites(newSites);
    }
  }, [value]);

  return (
    <>
      {error && <strong>Error: {JSON.stringify(error)}</strong>}
      {queryError && <>{queryError}</>}

      <MainPage
        sites={sites}
        queries={queries}
        submitQueries={submitQueries}
        limitResults={limitResults}
        loadMore={loadMore}
        loading={loading}
      />
    </>
  );
}

export default MainPageWrapper;
